module.exports = __webpack_public_path__ + "img/logo-m2n.2b894327.svg";